<template>
    <BaseBtn icon  v-on="$listeners">
      <v-icon>{{$store.state.icons.close}}</v-icon>
    </BaseBtn>
</template>

<script>
  import BaseBtn from "./BaseBtn";
  export default {
    components: {BaseBtn},
    name: "CardCloser",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>